
import spbkMixin from '~/mixin/or/spbkMixin'
import { commonfunc } from '~/mixin/common'
// import LayerRevwWrt from '~/components/pd/layer/LayerRevwWrt.vue' // 리뷰 작성 팝업
import { isShowTotalSelling } from '~/config/options'
import ThumbOverlay from '~/components/common/product/ThumbOverlay.vue'
import ProdEmblem from '~/components/common/product/ProdEmblem.vue'
import ProdPrice from '~/components/common/product/ProdPrice.vue'
import ProdNumber from '~/components/common/product/ProdNumber.vue'
import ProdFlag from '~/components/common/product/ProdFlag.vue'
import ProdName from '~/components/common/product/ProdName.vue'
import ProdOption from '~/components/common/product/ProdOption.vue'
import ProdRating from '~/components/common/product/ProdRating.vue'
import ShoppingbagButton from '~/components/common/product/ShoppingbagButton.vue'

export default {
  name: 'ProdUnit',
  components: {
    // LayerRevwWrt,
    ThumbOverlay,
    ProdEmblem,
    ProdPrice,
    ProdNumber,
    ProdFlag,
    ProdName,
    ProdOption,
    ProdRating,
    ShoppingbagButton
  },
  mixins: [spbkMixin, commonfunc],
  props: {
    item: { // 상품 데이터
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    idx: { // 상품 index
      type: Number
    },
    unitType: { // 상품 type
      type: String,
      default: 'general'
    },
    listGroup: { // 그룹 상품리스트 사용 여부
      type: Boolean,
      default: false
    },
    review: { // 리뷰 유닛
      type: Boolean,
      default: false
    },
    quantity: { // 수량 노출
      type: Boolean,
      default: false
    },
    close: { // 닫기 버튼 기능
      type: Boolean,
      default: false
    },
    cart: { // 장바구니 버튼 노출/비노출 여부
      type: Boolean,
      default: true
    },
    radio: { // 라디오 선택
      type: Boolean,
      default: false
    },
    contwriter: { // 사용자 등록 상품 type
      type: Boolean,
      default: false
    },
    ranking: { // 링킹 유닛
      type: Boolean,
      default: false
    },
    typeList: { // 리스트 타입
      type: Boolean,
      default: false
    },
    order: { // (메뉴)주문에서만 사용 - 가격 우측 정렬 등
      type: Boolean,
      default: false
    },
    reviewPopUpOpen: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      isShowTotalSelling,
      mbMngNo: '',
      sbpkSingle: {
        pdNo: '',
        spbkQy: '',
        spbkSeCd: '',
        chnlCd: '',
        onldPdNo: '',
        lsUpdrId: 'TestAddSpbk'

      },
      num: 0, // 수량
      swiperOpt: { // 묶음상품 swiper options
        slidesPerView: 4,
        loop: false,
        lazy: true,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      planSwiperOpt: { // 기획전 (신상품) swiper options
        slidesPerView: 2,
        loop: false,
        lazy: true,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      }
    }
  },
  computed: {
    reviewNum () {
      // console.log('reviewNum', Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR'))
      if (typeof this.item.reviewNum === 'number') {
        if (this.item.reviewNum > 9999) {
          return '+9,999'
        } else {
          return Number(this.item.reviewNum).toLocaleString('ko-KR')
        }
      } else if (Number(this.item.reviewNum.replace(/[^0-9]/g, '')) > 9999) {
        return '+9,999'
      } else {
        return Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    total () {
      // console.log('total', Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR'))
      if (typeof this.item.total === 'number') {
        if (this.item.total > 99999) {
          return '+99,999'
        } else {
          return Number(this.item.total).toLocaleString('ko-KR')
        }
      } else if (Number(this.item.total.replace(/[^0-9]/g, '')) > 99999) {
        return '+99,999'
      } else {
        return Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    prodPrice () {
      if (typeof this.item.price === 'number') {
        return Number(this.item.price).toLocaleString('ko-KR')
      } else {
        return Number(this.item.price.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    rankFlag () {
      if (typeof this.item.ranking.variance === 'number') {
        if (this.item.ranking.variance === 0) { // 변동없음
          return ''
        } else { // up & down
          return Math.abs(this.item.ranking.variance)
        }
      } else {
        return 'new'
      }
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (document.querySelectorAll('.goods-list.ugc.masonry').length > 0) {
      this.unitHeight()
    }
    const mbMngNo = this.$store.getters['session/getMbMngNo']
    if (mbMngNo) {
      this.mbMngNo = mbMngNo
    }
  },
  unmounted () {
  },
  methods: {
    prodNum (e) {
      if (typeof e === 'number') {
        if (e > 99999) {
          return '99,999+'
        } else {
          return Number(e).toLocaleString('ko-KR')
        }
      } else if (Number(e.replace(/[^0-9]/g, '')) > 99999) {
        return '99,999+'
      } else {
        return Number(e.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    toggleChk (event) {
      this.$emit('toggle-chk', {
        id: event.id,
        checked: event.chk
      })
    },
    alarmChk (event) {
      this.$emit('alarm-chk', {
        id: event.id,
        checked: event.chk
      })
    },
    unitHeight () {
      document.querySelectorAll('.goods-list.ugc.masonry > .goods-unit').forEach((el) => {
        // console.log(el.clientHeight)
        el.style.cssText = 'grid-row-end: span ' + (el.clientHeight + 0)
      })
    },
    prodClose (event) {
      this.$emit('prod-close', event)
    },
    prodUnitClick (event) {
      this.$emit('prod-unit-click', {
        orNo: event.orNo,
        pdNo: event.pdNo,
        item: event.item
      })
    },
    async addToCart (item) {
      this.sbpkSingle.mbMngNo = this.mbMngNo
      this.sbpkSingle.pdNo = item.pdNo
      this.sbpkSingle.spbkQy = 1
      this.sbpkSingle.spbkSeCd = '01'
      this.sbpkSingle.chnlCd = '01'
      this.sbpkSingle.onldPdNo = item.onldPdNo
      this.sbpkSingle.exhPdNm = item.exhPdNm ? item.exhPdNm : '' // GTM 작업을 위한 파라미터 추가
      this.sbpkSingle.price = item.price ? item.price : '' // GTM 작업을 위한 파라미터 추가
      this.sbpkSingle.onlSclCd = item.onlSclCd ? item.onlSclCd : '' // GTM 작업을 위한 파라미터 추가

      const result = await this.addSpbk(this.sbpkSingle)
      this.showMsg(result)
    },
    preventEventDup () {
    },
    // 메시지 노출
    showMsg (result) {
      console.log('showMsg')
      console.log(result)

      if (result.row > 0) {
        this.$confirm('장바구니에 추가되었습니다. 장바구니로 이동하시겠습니까?', '', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          dangerouslyUseHTMLString: true
        }).then(() => {
          console.log('장바구니 이동 경로 필요')
        }).catch(() => {
        })
      } else if (result.row === -1) {
        this.$alert('장바구니에 같은 상품이 있습니다.', '', {
          confirmButtonText: '확인'
        })
      } else {
        this.$alert('실패', '', {
          confirmButtonText: '확인'
        })
      }
    }
  }
}
